import React from 'react';
import ModelWorking from '../common/model-working';
import KEY from '../common/keylist';
type Props = {
    title: string;
    desc: any;
};

const YiiModelsOfWorking: React.FC<Props> = ({ title, desc }) => {
    return (
        <div className="section-py bg-grey dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="text-center lg:col-span-10 lg:col-start-2 pb-50">
                        <p
                            className="text-primary mb-2.5 fs-lg fw-700"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            Models of Working
                        </p>
                        <h2 className=" mb-2.5" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            {/* Engagement models to hire the best developers */}
                            {title}
                        </h2>
                        <p className="fw-600 mb-0" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            {desc}
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-3 lg:grid-cols-2 md:grid-cols-2 text-secondary">
                    <ModelWorking
                        path={'/img/technology/ic-dedicated-team.svg'}
                        height={64}
                        width={64}
                        alt="dedicated-team"
                        title="dedicated-team"
                        modelWorkingTitle="Dedicated Team"
                        url={'/dedicated-team-model'}
                    >
                        <>
                            <KEY text="Long-term collaboration" className="fs-md" />
                            <KEY text="Highly scalable team" className="fs-md" />
                            <KEY text="Complete control of the team" className="fs-md" />
                            <KEY text="Complex projects" className="fs-md" />
                        </>
                    </ModelWorking>
                    <ModelWorking
                        path={'/img/technology/ic-fixed-cost.svg'}
                        height={64}
                        width={64}
                        alt="fixed-cost"
                        title="fixed-cost"
                        modelWorkingTitle="Fixed Cost"
                        url={'/fixed-cost-model'}
                    >
                        <>
                            <KEY text="Short-medium term collaboration" className="fs-md" />
                            <KEY text="Low scalable team" className="fs-md" />
                            <KEY text="Detailed specifications" className="fs-md" />
                            <KEY text="Clean deadlines" className="fs-md" />
                        </>
                    </ModelWorking>
                    <ModelWorking
                        path={'/img/technology/ic-time-material.svg'}
                        height={64}
                        width={64}
                        alt="time-material"
                        title="time-material"
                        modelWorkingTitle="Time & Material"
                        url={'/time-material-model'}
                    >
                        <>
                            <KEY text="Short-long term collaboration" className="fs-md" />
                            <KEY text="Flexible budget and timeframe" className="fs-md" />
                            <KEY text="Complete control over the process" className="fs-md" />
                            <KEY text="Highly scalable team" className="fs-md" />
                        </>
                    </ModelWorking>
                </div>
            </div>
        </div>
    );
};

export default YiiModelsOfWorking;
